module.exports = __webpack_public_path__ + "media/images/en_private_corner_pres_still-1ae26b5a.jpg";